<div class="modal-content">
  <div class="modal-header">
    <p class="heading lead" > {{ heading }} </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.close()">
      <span aria-hidden="true" class="white-text">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ng-content></ng-content>
  </div>
  <div class="modal-footer">
    <button type="button" pButton class="relative waves-light" (click)="clicked(true)"><i [ngClass]="[yesButtonIcon, 'eca-btn-' + yesButtonColor]" *ngIf="yesButtonIcon"></i> {{yesButtonText}}</button>
    <button type="button" pButton class="waves-light" (click)="clicked(false)" aria-label="Close"><i [ngClass]="[noButtonIcon, 'eca-btn-' + noButtonColor]" *ngIf="noButtonIcon"></i> {{noButtonText}}</button>
  </div>
</div>
